import React, { useState, useContext } from "react";
import "../styles/ReportsDropdown.scss";
import { GlobalContext } from "../context/GlobalContext";
import Button from "@mui/material/Button";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "react-oidc-context";
import ApiService from "../services/ApiService";

const ReportsDropdown = () => {
  const { state } = useContext(GlobalContext);
  const { allReleases } = state;
  const auth = useAuth();
  const [selectedReleaseId, setSelectedReleaseId] = useState("");
  const [open, setOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setPdfUrl(null);
    setSelectedReleaseId("");
    setIsLoading(false);
    setLoadError(false);
  };

  const handleChange = async (event) => {
    const releaseId = event.target.value;
    setSelectedReleaseId(releaseId);
    // Reset state, open modal, and show spinner
    setPdfUrl(null);
    setLoadError(false);
    setIsLoading(true);
    setOpen(true);

    try {
      await loadPdf(releaseId);
    } catch (err) {
      console.error("Failed to fetch report PDF:", err);
      setLoadError(true);
    } finally {
      setIsLoading(false);
    }
  };


  // Add this function
const loadPdf = async (rid = selectedReleaseId) => {
  setIsLoading(true);
  setLoadError(false);
  setPdfUrl(null);
  try {
    const accessToken = auth.user?.access_token;
    if (!accessToken) throw new Error("Missing access token");
    if (!rid) throw new Error("Missing releaseId");

    // fetch presigned URL for embedding
    const { url } = await ApiService.getReleaseReportUrl(rid, accessToken, { mode: "embed" });
    setPdfUrl(url);
  } catch (err) {
    console.error("Failed to fetch report PDF:", err);
    setLoadError(true);
  } finally {
    setIsLoading(false);
  }
};


  

  const parseTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="rd-main-container">
      <span className="rd-title">List of release reports</span>
      <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 400 }} size="small">
        <InputLabel
          id="demo-select-small-label"
          sx={{
            color: "var(--purple)",
            "&.Mui-focused": {
              color: "var(--purple)",
            },
          }}
        >
          Report
        </InputLabel>
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={selectedReleaseId}
          label="Report"
          onChange={handleChange}
          sx={{
            color: "white",
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--purple)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--purple)",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--purple)",
            },
            svg: {
              color: "white",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                color: "white",
                background: "rgba(35, 50, 70, 0.5)",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(6px)",
                border: "1px solid var(--purple)",
                borderRadius: "6px",
                WebkitBackdropFilter: "blur(10px)",
              },
            },
          }}
        >
          {allReleases
            .slice()
            .sort((a, b) => new Date(b.CreationTimestamp) - new Date(a.CreationTimestamp))
            .map((release) => (
              <MenuItem
                key={release.ID}
                value={release.ID}
              >
                {parseTimestamp(release.CreationTimestamp)} – release_note.pdf
                
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {/* Modal for PDF display */}
      <Modal open={open} onClose={handleClose}>
        {/* Always render this Box as the direct child of Modal */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isLoading ? "undefined" : "70%",
            height: isLoading ? "undefined" : "90%",
            bgcolor: "transparent",
            p: 0,
            border: "none",
            outline: "none",
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isLoading ? (
            <CircularProgress sx={{ color: "var(--purple)" }} size={80} thickness={4} />
          ) : loadError ? (
            <Box
              sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: "6px",
                textAlign: "center",
              }}
            >
              <p style={{ color: "black" }}>Failed to load PDF.</p>
              <Button variant="contained" color="error" onClick={handleClose}>
  Close
</Button>
            </Box>
          ) : pdfUrl ? (
            // 3) If PDF loaded successfully, show the iframe
            <iframe
              src={pdfUrl}
              title="PDF Report"
              width="100%"
              height="100%"
              style={{
                borderRadius: "6px",
                backgroundColor: "white",
              }}
            />
          ) : (
            // 4) (Optional) This case should not usually occur, but
            //    if neither loading nor pdfUrl are set, we can render nothing or a placeholder.
            null
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default ReportsDropdown;
